import React from "react";
import _ from "lodash";
import moment from "moment";

const DashboardTable = ({ title, parameterList, data }) => {
  return _.isEmpty(data) ? null : (
    <table className="table table-sm table-hover text-right text-nowrap">
      <caption style={{ captionSide: "top", fontWeight: 700, padding: 0 }}>
        {title}
      </caption>
      <thead>
        <tr>
          <th style={{ width: "40%" }} className="text-left">
            Name
          </th>
          <th>Current</th>
          <th>Average ({data[parameterList[0]].data.length})</th>
        </tr>
      </thead>
      <tbody>
        {parameterList.map(parameter => (
          <tr key={parameter}>
            <td className="text-left">{data[parameter].Name}</td>
            <td>
              {data[parameter].data.length > 0 &&
              moment(data[parameter].data[0].PARAM_DATE).isSame(
                moment(),
                "day"
              ) &&
              data[parameter].data[0].PARAM_VALUE
                ? data[parameter].data[0].PARAM_VALUE.toFixed(
                    data[parameter].Precision
                  )
                : 0}
              {getCaret(data, parameter)}
            </td>
            <td className="font-italic">
              {data[parameter].data.length > 0 &&
                getAverage(data[parameter].data).toFixed(
                  data[parameter].Precision
                )}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
  // return (
  //   <table className="table table-sm table-hover text-right text-nowrap">
  //     <caption style={{ captionSide: "top", fontWeight: 700, padding: 0 }}>
  //       {title}
  //     </caption>
  //     <thead>
  //       <tr>
  //         <th style={{ width: "40%" }} className="text-left">
  //           Name
  //         </th>
  //         <th>Current</th>
  //         <th>
  //           Average ({!_.isEmpty(data) && data[parameterList[0]].data.length})
  //         </th>
  //       </tr>
  //     </thead>
  //     <tbody>
  //       {parameterList.map(parameter => (
  //         <tr key={parameter}>
  //           <td className="text-left">
  //             {!_.isEmpty(data) && data[parameter].Name}
  //           </td>
  //           <td>
  //             {!_.isEmpty(data) &&
  //               data[parameter].data.length > 0 &&
  //               moment(data[parameter].data[0].PARAM_DATE).isSame(
  //                 moment(),
  //                 "day"
  //               ) &&
  //               data[parameter].data[0].PARAM_VALUE.toFixed(
  //                 data[parameter].Precision
  //               )}
  //             {!_.isEmpty(data) && getCaret(data, parameter)}
  //           </td>
  //           <td className="font-italic">
  //             {!_.isEmpty(data) &&
  //               data[parameter].data.length > 0 &&
  //               getAverage(data[parameter].data).toFixed(
  //                 data[parameter].Precision
  //               )}
  //           </td>
  //         </tr>
  //       ))}
  //     </tbody>
  //   </table>
  // );
};

function getCaret(data, parameter) {
  let upColour = "text-success";
  let downColour = "text-danger";
  if (!data[parameter].Goal) return;
  if (data[parameter].data.length === 0) return;
  if (data[parameter].Goal === "Min") {
    upColour = "text-danger";
    downColour = "text-success";
  }
  if (data[parameter].data[0].PARAM_VALUE > getAverage(data[parameter].data)) {
    return <i className={`fas fa-caret-up ${upColour} ml-1`}></i>;
  } else {
    return <i className={`fas fa-caret-down ${downColour} ml-1`}></i>;
  }
}

function getAverage(data) {
  const sum = data.reduce((a, b) => ({
    PARAM_VALUE: a.PARAM_VALUE + b.PARAM_VALUE
  }));
  const avg = sum.PARAM_VALUE / data.length;
  return avg;
}

export default DashboardTable;
